module.exports = __webpack_public_path__ + "static/media/viscount-sustained-imagery.148970a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/viscount-sustained-imagery.mp3
// module id = p6Yd
// module chunks = 0